/**
 * @fileoverview GET handler for the "/companies/:company_id/developers/:developer_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { getCompaniesCompanyIdDevelopersDeveloperIdCacheKey } from "./constants";
import type { DeveloperJson } from "./types";

export const getCompaniesCompanyIdDevelopersDeveloperId = reactQueryFetcherAdapter(
  getCompaniesCompanyIdDevelopersDeveloperIdCacheKey,
  (signal: AbortSignal, companyId: string, developerId: string): Promise<DeveloperJson> => {
    return fetch(`/companies/${companyId}/developers/${developerId}`, "GET", {}, { signal });
  }
);
